import React from "react";
import Scroll from "./Scroll";
import { ProductConsumer } from "../../../Context/AddProWakel";
import NumberFormat from "react-number-format";
const ScrollTable = ({ savekrdn }) => {
  return (
    <>
      <ProductConsumer>
        {(value) => {
          const {
            DeleteSail,
            R_dataTable,
            R_joripara,
            R_del_dis,
            R_wasl,
            R_ItemSelect
          } = value;
          const Rent = R_dataTable.map((user, i) => {
            return (
              <tr
                key={i}
                className={`f4 ${user.nawisht == R_ItemSelect ? "bg-secondary text-black" : ""
                  }`}
                style={{
                  color: `${i == 0 ? "white" : "black"}`,
                  backgroundColor: `${i == 0 ? "#20B2AA" : ""}`
                }}
              >
                <td className="fk" style={{ border: "2px solid #f0ad4e" }}>
                  {R_joripara == "دۆلار" ? (
                    <NumberFormat
                      value={
                        Number.isInteger(Number(user.kodolar))
                          ? Number(user.kodolar)
                          : Number(user.kodolar).toFixed(2)
                      }
                      displayType={"text"}
                      thousandSeparator={true}
                    />
                  ) : (
                    <NumberFormat
                      value={
                        Number.isInteger(Number(user.kodinar))
                          ? Number(user.kodinar)
                          : Number(user.kodinar).toFixed(2)
                      }
                      displayType={"text"}
                      thousandSeparator={true}
                    />
                  )}
                </td>
                {/* <td className="fk" style={{ border: "2px solid #f0ad4e" }}>
                  {user.reja}
                </td> */}
                <td className="fk" style={{ border: "2px solid #f0ad4e" }}>
                  {
                    <NumberFormat
                      value={user.nrx}
                      displayType={"text"}
                      thousandSeparator={true}
                    />
                  }{" "}
                </td>
            
                <td className="fk" style={{ border: "2px solid #f0ad4e" }}>
                  {(() => {
                    const num = Number(user.carton);
                    if (Number.isInteger(num)) {
                      return num;
                    }

                    const decimalPlaces = num.toString().split('.')[1]?.length || 0;

                    if (decimalPlaces <= 2) {
                      return num.toFixed(2);
                    } else {
                      return num.toFixed(3);
                    }
                  })()}
                </td>
                    <td className="fk" style={{ border: "2px solid #f0ad4e" }}>
                  {user.darzan}
                </td>
                <td className={`fk `} style={{ border: "2px solid #f0ad4e" }}>
                  {user.nawisht}
                </td>
                {/* <td className="fk" style={{ border: "2px solid #f0ad4e" }}>
                  {user.jamaraysht}
                </td> */}
                <td className="fk" style={{ border: "2px solid #f0ad4e" }}>
                  {user.raqam}
                </td>
                <td style={{ border: "2px solid #f0ad4e" }}>
                  <button
                    onClick={() => DeleteSail(user._id, user, R_wasl, i)}
                    disabled={
                      R_del_dis == true || savekrdn == true ? true : null
                    }
                    className="btn btn-danger "
                  >
                    <i className="fa fa-minus" aria-hidden="true"></i>
                  </button>
                </td>
              </tr>
            );
          });

          return (
            <div className="RR">
              <table
                id="example"
                className="table table-striped table-bordered  tc m-auto"
              >
                <thead>
                  <tr className="text-warning f4">
                    <th style={{ border: "2px solid #f0ad4e" }}>
                      {R_joripara == "دۆلار" ? "$ کۆی گشتی" : "ID کۆی گشتی"}
                    </th>
                    {/* <th style={{ border: "2px solid #f0ad4e" }}>ڕێژە</th> */}
                    <th style={{ border: "2px solid #f0ad4e" }}>نرخ</th>
                    <th style={{ border: "2px solid #f0ad4e" }}>کارتۆن</th>
                    <th style={{ border: "2px solid #f0ad4e" }}>دەرزەن</th>

                    <th style={{ border: "2px solid #f0ad4e" }}>ناوی شتەکان</th>
                    {/* <th style={{ border: "2px solid #f0ad4e" }}>ژ.شتەکان</th> */}
                    <th style={{ border: "2px solid #f0ad4e" }}>کۆد</th>
                    <th style={{ border: "2px solid #f0ad4e" }}>x</th>
                  </tr>
                </thead>
                <tbody>{Rent}</tbody>
              </table>
            </div>
          );
        }}
      </ProductConsumer>
    </>
  );
};

export default ScrollTable;
